import React, { Component, Suspense, lazy } from "react";
import ProductBase from './product-base.jsx';
import wishlist from '../../components/wishlist';
import toast from '../../components/toast';
import { postGetTranslations } from '../../apis/translations';

class Product extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isInWishlist: false,
            isLoadingWishlist: false,
            translationLookup: {} // Initialize as an empty object
        };

        this.handleWishlistClick = this.handleWishlistClick.bind(this);
    }

    isPujadas() {
        let isPujadas = window.location.host == ("localhost:8012") || window.location.hostname.includes("pujadas.es");
        let isAuthenticated = this.props.useDealerPrice && this.props.dealerPrice != null;  // if useDealerPrice is true, we're on Pujadas.  If dealer price is null, the user is not authenticated

        return isPujadas && isAuthenticated;
    }

    componentDidMount() {
        // Define translation keys
        let translationKeys = {
            WhisListRemoved: 'ProductItem.Text.WhisListRemoved',
            WhisListRemovedError: 'ProductItem.Text.WhisListRemovedError',
            WhisListAdded: 'ProductItem.Text.WhisListAdded',
            WhisListAddedError: 'ProductItem.Text.WhisListAddedError',
            BtnAddWishList: 'ProductItem.Text.BtnAddWishList',
            FilterSearchMessage: 'Filters.Label.SearchMessage'
        };

        // Fetch translations and update state
        postGetTranslations([
            translationKeys.WhisListRemoved,
            translationKeys.WhisListRemovedError,
            translationKeys.WhisListAdded,
            translationKeys.WhisListAddedError,
            translationKeys.BtnAddWishList,
        ]).then(translations => {
            this.setState({
                translationLookup: {
                    WhisListRemoved: translations[translationKeys.WhisListRemoved] ?? 'Removed from your wish list',
                    WhisListRemovedError: translations[translationKeys.WhisListRemovedError] ?? 'There was an error trying to remove this product from your wish list',
                    WhisListAdded: translations[translationKeys.WhisListAdded] ?? 'Added to your wish list',
                    WhisListAddedError: translations[translationKeys.WhisListAddedError] ?? 'There was an error trying to add this product to your wish list',
                    BtnAddWishList: translations[translationKeys.BtnAddWishList] ?? 'Add to Wish List'
                }
            });
        }).catch(error => {
            console.log(error);
        });
    }

    componentWillMount() {
        wishlist.hasProduct(this.props.skuNumber).then(result => this.setState({
            isInWishlist: result
        }));
    }

    handleWishlistClick(e) {
        wishlist.hasProduct(this.props.skuNumber).then(result => {
            this.setState({
                isInWishlist: result,
                isLoadingWishlist: true
            });
            if (result) {
                wishlist.delete(this.props.skuNumber)
                    .then(data => {
                        toast.success(this.state.translationLookup.WhisListAdded);
                        this.setState({
                            isInWishlist: false
                        });
                    })
                    .catch(error => {
                        toast.error( this.state.translationLookup.WhisListRemovedError );
                    })
                    .finally(() => {
                        this.setState({
                            isLoadingWishlist: false
                        });
                    });
            }
            else {
                wishlist.add(this.props.skuNumber)
                    .then(data => {
                        toast.success( this.state.translationLookup.WhisListAdded );
                        this.setState({
                            isInWishlist: true
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error(this.state.translationLookup.WhisListAddedError );
                    })
                    .finally(() => {
                        this.setState({
                            isLoadingWishlist: false
                        });
                    });
            }
        });
    }


    render() {
        let actions;
        
        let wishlistBtn =
            <button class="btn btn-outline-alt" type="button" onClick={this.handleWishlistClick} disabled={this
                .state.isLoadingWishlist}>
                <svg className="icon icon-heart"><use xlinkHref="#icon-heart"></use></svg>
                <span>{ this.state.translationLookup.BtnAddWishList }</span>
            </button>;


        if (this.state.isInWishlist) {
            wishlistBtn =
                <button class="btn btn-outline-alt" type="button" onClick={this.handleWishlistClick} disabled={this.state.isLoadingWishlist}>
                    <svg className="icon icon-heart-filled"><use xlinkHref="#icon-heart-filled"></use></svg>
                    <span>{this.state.translationLookup?.BtnAddWishList || 'Add to Wish List'}</span>
                </button>;
        }

        let addToProjectBtn = "";

        if (window.location.host == ("localhost:44335")
            || this.isPujadas()
            || window.location.host == ("localhost:7012")
            || window.location.hostname.includes("vollrathfoodservice.com")
        ) {
            const QuickAddWrapper = lazy(() => import("../../../site-js/react/components/project-builder/quick-add-query-client.jsx"));
            addToProjectBtn = <Suspense><QuickAddWrapper item={this.props} /></Suspense>;
        }

        actions = <div class="full-card-actions">
            {this.props.hidePrice ? wishlistBtn : addToProjectBtn }
        </div>

        return (
            <>
                <ProductBase {...this.props} actions={actions} />
            </>
        );
    }
}

export default Product;